import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/landing/HeroSection";
import ProblemSection from "@/components/landing/ProblemSection";
import SolutionSection from "@/components/landing/SolutionSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import VerifiedCarriersSection from "@/components/landing/VerifiedCarriersSection";
import TransparencySection from "@/components/landing/TransparencySection";
import FAQSection from "@/components/landing/FAQSection";
import CarrierCTASection from "@/components/landing/CarrierCTASection";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <HowItWorksSection />
        <VerifiedCarriersSection />
        <TransparencySection />
        <FAQSection />
        <CarrierCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
